export default "__VITE_ASSET__xsrsL1a8__"